export default "__VITE_ASSET__d47eca99__"